/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2022-12-20 18:57:19
 * @LastEditors: taoyuan taoyuan@originqc.com
 * @LastEditTime: 2023-03-22 14:29:26
 * @FilePath: \qcloud-web-pc-4.0\src\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createRoot } from 'react-dom/client'
// 国际化
import './locale/index'
// 路由
import { BrowserRouter } from 'react-router-dom'
import Layout from './components/layout/index'
// 全局状态管理
import { Provider } from 'react-redux'
import { store } from './redux/store'
// 样式
import './assets/css/reset.scss'
import './assets/css/global.scss'
import './assets/css/theme.scss'

import reportWebVitals from './reportWebVitals'
import { ConfigProvider } from 'antd';

import { getLanguageFromRedux } from './redux/common'
import { ErrorBoundary } from '@/components/error-boundary';

import zhCn from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';

import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/en';

const container = document.getElementById('root')
const root = createRoot(container as HTMLElement)
const language = getLanguageFromRedux();
dayjs.locale(language === 'zh' ? 'zh-cn' : 'en');
const localeMap = {
  zh: zhCn,
  en: enUS
}

root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <ConfigProvider locale={localeMap[language]}>
          <ErrorBoundary>
            <Layout />
          </ErrorBoundary>
        </ConfigProvider>
      </Provider>
    </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
